<button mat-raised-button color="basic" class="remove-selected-processes-button" (click)="removeSelectedProcesses()"
    [disabled]="!isActive">
    <mat-icon matTooltip="Delete selected processes">delete</mat-icon>
</button>
